import { FC, PropsWithChildren } from "react";

export const SidebarMainContent: FC<PropsWithChildren> = ({ children }) => {
  return (
    <div className="mb-0.5 flex flex-initial grow flex-col overflow-y-auto px-3 py-3 text-secondary-foreground">
      {children}
    </div>
  );
};
